<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center mt-8>
        <!-- Feeds-->

        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center mb-5>
              <v-flex xs12 md8>
                <div
                  class="font-weight-bold defaultColor--text"
                  style="font-size: 20px"
                >
                  {{ $t("title.liveStreamRequest") }}
                </div>
                <v-spacer />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer">
                <v-list
                  class="pl-1 mx-4"
                  style="background-color: rgba(0, 0, 0, 0)"
                >
                  <!-- aylavblog -->
                  <template v-for="(item, index) in items">
                    <v-divider :inset="false" v-if="index != 0"></v-divider>
                    <v-list-item
                      style="
                        cursor: pointer; background-color: rgba(0, 0, 0, 0);
                      "
                      :class="'defaultColorLightThree py-1 rounded-lg my-2'"
                    >
                      <!-- <v-list-item-avatar>
                        <v-img :src="item.User.Avatar"></v-img>
                      </v-list-item-avatar> -->

                      <v-list-item-content class="pl-3">
                        <v-list-item-title
                          v-html="getText(item)"
                          class="mb-7 defaultColor--text"
                        ></v-list-item-title>
                        <v-layout row my-2 pr-5>
                          <v-spacer />
                          <v-btn
                            color="greenColor"
                            dark
                            rounded
                            elevation="0"
                            class="text-capitalize mr-4 px-10"
                            :loading="buttonLoading"
                            @click="handleRequest(item, true)"
                          >
                            {{ $t("buttons.confirm") }}
                          </v-btn>
                          <v-btn
                            color="redColor"
                            dark
                            rounded
                            elevation="0"
                            class="text-capitalize px-10"
                            :loading="buttonLoading"
                            @click="handleRequest(item, false)"
                          >
                            {{ $t("buttons.reject") }}
                          </v-btn>
                        </v-layout>
                      </v-list-item-content>

                      <v-list-item-action>
                        <!-- <v-icon v-if="!item.IsSeen" small color="defaultColor">
                          mdi-checkbox-blank-circle
                        </v-icon> -->
                      </v-list-item-action>
                    </v-list-item>
                  </template>

                  <no-content v-if="items.length <= 0" />
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import BroadcastService from "../../services/BroadcastService";
import NoContent from "../../components/General/NoContent.vue";
export default {
  data: () => {
    return {
      page: 1,
      per_page: 15,
      paginationStop: false,
      items: [],
      buttonLoading: false,
    };
  },
  components: {
    NoContent,
  },
  methods: {
    getLiveRequestList() {
      this.loading = true;
      setPageLoading(true);
      BroadcastService.getLiveStreamRequests()
        .then((res) => {
          this.items = res.data.Result;
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
        })
        .then(() => {
          this.loading = false;
          setPageLoading(false);
        });
    },

    handleRequest(item, flag = false) {
      console.log("Item >> ", item);
      //If flag is true approve
      let body = {
        UserId: item.UserId,
        status: flag ? "Approved" : "Rejected",
      };
      this.buttonLoading = true
      console.log("body >> ", body);
      BroadcastService.handleLiveStreamRequest(body)
        .then((res) => {
          showSuccess(this.$t("description.transactionSuccessful"));
          this.items = this.items.filter(x => x.Id != item.Id)
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
        })
        .then(() => {
          this.buttonLoading = false
        });
    },

    getText(item) {
      return `${item.User.FullName} ${this.$t(
        "description.liveStreamRequestText"
      )}`;
    },
  },
  computed: {},
  destroyed() {},
  mounted() {
    this.getLiveRequestList();
  },
  watch: {},
};
</script>
